import {Component, ChangeDetectorRef} from '@angular/core';
import {Router} from "@angular/router";
import {DataService} from "../services/data.service";
import {EditDataService, Info} from "../services/edit-data.service";
import {ToastsManager} from 'ng2-toastr/ng2-toastr';
import {MdDialog} from '@angular/material';

@Component({
  selector: 'admin',
  templateUrl: './admin.component.html',
  providers: [ToastsManager],
  styleUrls: ['./admin.component.scss'],
})

export class AdminComponent {
  password: any;
  editText: any;
  rules: Info[];
  public data: any = [];
  footer: any;
  modal:any;
  failPage:any;
  successPage:any;
  background: any;
  backgroundImg: string = " ";
  headerImg: string = " ";
  logo: any;
  logoData: any;
  backData: any;
  errorMessage: any;
  _body: any;

  /**
   * Review
   * Todo:
   * Импортируемые сервисы делать приватными
   */
  constructor(public router: Router,
              public editDataService: EditDataService,
              private changeDetectorRef: ChangeDetectorRef,
              public dialog: MdDialog) {
  }

  ngOnInit() {
    this.data = this.editDataService.getDataAdmin();
  }

  openDialog() {
    this.dialog.open(ConfirmDialog);
  }

  loginRoute() {
    this.router.navigate(['/login']);
  }

  upload() {
    this.password = this.editDataService.getPassword();
    /**
     * Review
     * Todo:
     * Приводить обсёрвы к промисам
     */
    this.editDataService.setSettings(this.logoData, this.backData).subscribe(
      data => {
       /* this.openDialog();*/
      },
      error => {
        error = JSON.parse(error._body);
      })
  }

  /**
   * Review
   * Todo:
   * Убрать все лишние переносы строк
   */
  /**
   * Review
   * Todo:
   * Для функций-обработчиков событий дописывать onFileChange
   */
  fileChange(inputBack, inputLogo, type) {
    if (type == 'header') {
      this.logoData = inputLogo.files[0];
      this.readFiles(inputLogo.files[0], type);
    }

    if (type == 'background') {
      this.backData = inputBack.files[0];
      this.readFiles(inputBack.files[0], type);
    }
  }

  readFile(file, reader, callback) {

    reader.onload = () => {

      callback(reader.result);
    };

    reader.readAsDataURL(file);
  }

  readFiles(files, type) {

    let reader = new FileReader();

    this.readFile(files, reader, (result) => {

      /**
       * Review
       * Todo:
       * Никаких var!
       */
      var img = document.createElement("img");
      img.src = result;

      this.resize(img, 500, 250, (resized_jpeg)=> {

        if (type == 'header') {
          /**
           * Review
           * Todo:
           * resized_jpeg - привести к нормальному стилю(lowerCamelCase)
           */
          this.headerImg = resized_jpeg;
        }

        if (type == 'background') {
          this.backgroundImg = resized_jpeg;
        }

      });
    });

    // When all files are done This forces a change detection
    this.changeDetectorRef.detectChanges();
  }
  /**
   * Review
   * Todo:
   * resized_jpeg - привести к нормальному стилю(lowerCamelCase)
   * Что вообще делает эта фнукция, зачем здесь используется canvas для работы с обычными картинками?
   */
  resize(img, MAX_WIDTH: number, MAX_HEIGHT: number, callback) {
    /**
     * Review
     * Todo:
     * Комменты должны быть в рамках одного проекта на одном языке
     */
    // This will wait until the img is loaded before calling this function
    return img.onload = () => {
      /**
       * Review
       * Todo:
       * Логов не должно быть
       */
      console.log("img loaded");
      // Get the images current width and height
      /**
       * Review
       * Todo:
       * Снова вары
       */
      var width = img.width;
      var height = img.height;

      // Set the WxH to fit the Max values (but maintain proportions)
      if (width > height) {
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width;
          width = MAX_WIDTH;
        }
      } else {
        if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height;
          height = MAX_HEIGHT;
        }
      }
      // create a canvas object
      var canvas = document.createElement("canvas");

      // Set the canvas to the new calculated dimensions
      canvas.width = width;
      canvas.height = height;
      var ctx = canvas.getContext("2d");

      ctx.drawImage(img, 0, 0, width, height);

      // Get this encoded as a jpeg
      // IMPORTANT: 'jpeg' NOT 'jpg'
      var dataUrl = canvas.toDataURL('image/jpeg');

      // callback with the results
      callback(dataUrl, img.src.length, dataUrl.length);
    };
  }

}

@Component({
  selector: 'dialog',
  templateUrl: './dialog-confirm.html',
  styleUrls: ['./admin.component.scss'],
})
export class ConfirmDialog {}



// WEBPACK FOOTER //
// /home/backend/NasheDelo/WebLombard/client/src/app/admin/admin.component.ts